import * as REQUEST_STATES from 'forms-utils-lib/RequestState';
import { handleAction } from 'redux-actions';
import { REQUEST_FORM_TRANSLATION, SUCCEED_FORM_TRANSLATION, FAIL_FORM_TRANSLATION } from 'FormsUI/actions/FormDefinition/translateFormDefinition';
import reduceReducers from 'FormsUI/utils/ReduceReducers';
const initialState = {
  formTranslationRequestState: REQUEST_STATES.NOT_REQUESTED
};
export const requestFormTranslationReducer = handleAction(REQUEST_FORM_TRANSLATION, () => ({
  formTranslationRequestState: REQUEST_STATES.REQUESTED
}), initialState);
export const succeededFormTranslationReducer = handleAction(SUCCEED_FORM_TRANSLATION, () => ({
  formTranslationRequestState: REQUEST_STATES.SUCCEEDED
}), initialState);
export const failFormTranslationReducer = handleAction(FAIL_FORM_TRANSLATION, () => ({
  formTranslationRequestState: REQUEST_STATES.FAILED
}), initialState);
export default reduceReducers(requestFormTranslationReducer, succeededFormTranslationReducer, failFormTranslationReducer);